(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["micro-app-4-main"] = factory();
	else
		root["micro-app-4-main"] = factory();
})(window, function() {
return 